import React, { useRef, useEffect, useState } from "react";
import { useReportViewModel } from "./ReportViewModel";
import { Box, CircularProgress, Typography, Grid, Button } from "@mui/material";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';

export const Report = () => {
  const mountRef = useRef(null);
  const { embedDashboardForRole, isLoading, error } = useReportViewModel();
  const [isFilterOpen, setFilterOpen] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({});

  useEffect(() => {
    if (mountRef.current) {
      embedDashboardForRole(mountRef.current, selectedFilters);
    }
  }, [selectedFilters]);

  const handleFilterChange = (values) => {
    setSelectedFilters(values);
  };

  const handleFilterSection = (value) => {
    setFilterOpen(value);
  };

  if (error && typeof error === 'string' && error.length > 0) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="200px"
      >
        <Typography color="error" variant="body1">
          {error}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ width: "100%", height: "100%", position: "relative" }}>
      <Box paddingBottom={2}>
        <Grid container spacing={3} direction="row">
          <Grid item xs={12}>
            <Button
              variant="contained"
              onClick={() => handleFilterSection(!isFilterOpen)}
              startIcon={<FilterAltOutlinedIcon />}
            >
              Filter By
            </Button>
          </Grid>
        </Grid>
      </Box>

      {isLoading && (
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          display="flex"
          justifyContent="center"
          alignItems="center"
          bgcolor="rgba(255, 255, 255, 0.8)"
          zIndex={1}
        >
          <CircularProgress />
        </Box>
      )}
      
      <Box 
        ref={mountRef} 
        id="dashboard-container"
        sx={{ width: '100%', height: '100%' }} 
      />
    </Box>
  );
};

export default Report;
